/* eslint-disable no-underscore-dangle */
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export interface AddedPostLike {
  token: string | null,
  jobId: string;
  userId: string;
  like: string;
}

export const fetchAllLikes = createAsyncThunk('likes/fetchAllLikes', async (token: string | null) => {
  const response = await axios.get(`${process.env.REACT_APP_API_JOBS_URL}/likes/likes`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  return response.data;
});

export const addLike = createAsyncThunk(
  'likes/addLike',
  async (newLike: AddedPostLike) => {
    const { token, ...otherLikeFeatures } = newLike;
    const response = await axios.post(`${process.env.REACT_APP_API_JOBS_URL}/likes/postlike`,
      otherLikeFeatures,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    return response.data;
  },
);
